export default __webpack_public_path__ + "static/media/logo.a01e7875.svg";